import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAtom } from 'jotai';
import { useMutation, useQuery } from '@tanstack/react-query';

import { fetch_all, fetch_one } from "../../../lib/v31lib";
import { loginAtom } from '../../../lib/auth';

import {
  Button,
  DialogActions,
  Grid
} from '@mui/material';

import {
  TagChip,
  Typography
} from '../../../components/v2/styled';
import { Base } from './Base';

import { User } from '../../../models/User';
import { UserTag } from '../../../models/UserTag';

// const { DateTime } = require("luxon");

type Props = {
  open: boolean;
  setOpen: (b:boolean) => void;
  onClose?: () => void;
  userId: number;
  practiceId: number;
};

export const CoachTagLinker: FunctionComponent<Props> = ({userId, practiceId, open, setOpen, onClose}) => {
  const [login, setLogin] = useAtom(loginAtom);
  const theme = useTheme();
  // const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);

  const [tagIds, setTagIds] = useState<number[]>([]);

  const {
    data: object,
    isLoading: objectLoading,
    isError: objectError,
    isSuccess: objectSuccess,
    refetch: objectRefetch,
  } = useQuery({
    queryKey: ["user", 'short', practiceId, userId],
    queryFn: () =>
      fetch_one<User>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'user',
          id: userId,
          fields: [
            'id', 'user_tags'
          ],
          practice_id: practiceId
        },
        login
      ),
    enabled: !!practiceId && !!userId,
  });
  const {
    data: userTags,
    // isLoading: objectLoading,
    // isError: objectError,
    // isSuccess: objectSuccess,
    refetch: userTagsRefetch,
  } = useQuery({
    queryKey: ["user_tags", practiceId],
    queryFn: () =>
      fetch_all<UserTag>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'user_tag',
          fields: ['id', 'name', 'colour', 'bg_colour', 'extra_data', 'user_count'],
          order: "name ASC",
          per_page: 1000,
          page: 0,
          filter: {
            search: '',
            advanced: {
              practice_id: practiceId
            }
          },
          practice_id: practiceId
        },
        login
      ),
    enabled: !!practiceId && !!userId,
  });







  const mutationCustomAction = useMutation({
    mutationFn: (pars: {
      formData: any;
    }) => {
      return fetch_one<UserTag>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/custom_action`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      setOpen(false);
    },
  });








  
  useEffect(() => {
    if (!!object) {
      let tgs:number[] = [];

      (object.user_tags || []).forEach(tg => {
        if (!!tg.id) tgs.push(tg.id);
      });

      setTagIds(tgs);
    }
  }, [object]);

  return (<>
    <Base
      name="tag_linker"
      title={t("client.user_tags.link_to_user")}
      onClose={() => {
        if (!!onClose) onClose();
      }}
      content={<>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h5">{t("client.user_tags.linking.selected_tags")}</Typography>
          </Grid>
          <Grid item xs={12}>
            {(userTags || []).filter(fff => tagIds.indexOf(fff.id || 0) > -1).map(tg => <TagChip tag={tg} onClick={() => {setTagIds(tagIds.filter(ff => ff !== tg.id));}} sx={{marginBottom: 1}} />)}
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h5">{t("client.user_tags.linking.unselected_tags")}</Typography>
          </Grid>
          <Grid item xs={12}>
            {(userTags || []).filter(fff => tagIds.indexOf(fff.id || 0) < 0).map(tg => <TagChip tag={tg} onClick={() => {setTagIds([...tagIds, (tg.id || 0)]);}} sx={{marginBottom: 1}} />)}
          </Grid>
        </Grid>
      </>}
      actions={<DialogActions sx={{borderTop: '1px solid transparent', borderColor: theme.palette.primary.main}}>
        <Button
          onClick={(e) => {
            setOpen(false);
          }}
          color="primary"
        >{t("coach.general.actions.cancel")}</Button>
        <Button
          onClick={(e) => {
            mutationCustomAction.mutate({
              formData: {
                object: 'user_tag',
                class_action: "custom_api_update_tags",
                user_id: userId,
                practice_id: practiceId,
                user_tag_ids: tagIds
              }
            });
          }}
          color="primary"
        >{t("client.general.actions.save")}</Button>
      </DialogActions>}
      open={open}
      setOpen={setOpen}
    />
  </>);
}
